// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"ox_a bhy_qt bhy_a bhy_w","FaqAskQuestion__outdated":"ox_b bhy_vr bhy_xg"};